import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "card mb-5",
  ref: "root"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Operational health")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger d-flex justify-content-between align-items-center mb-0"
}
const _hoisted_5 = {
  key: 1,
  class: "placeholder-glow"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "placeholder col-12",
  style: {"height":"100px"}
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "row"
}
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted" }, "Failed transactions", -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted" }, "Pending transactions", -1)
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted" }, "Stale open coupons", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.error), 1),
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-danger",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry')))
            }, " Retry ")
          ]))
        : (!_ctx.loaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", {
                  class: _normalizeClass(["fs-2 fw-bold", _ctx.ops.failedTransactions > 0 ? 'text-danger' : ''])
                }, _toDisplayString(_ctx.ops.failedTransactions ?? 0), 3)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", {
                  class: _normalizeClass(["fs-2 fw-bold", _ctx.ops.pendingTransactions > 0 ? 'text-warning' : ''])
                }, _toDisplayString(_ctx.ops.pendingTransactions ?? 0), 3)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", {
                  class: _normalizeClass(["fs-2 fw-bold", _ctx.ops.staleOpenCoupons > 0 ? 'text-warning' : ''])
                }, _toDisplayString(_ctx.ops.staleOpenCoupons ?? 0), 3)
              ])
            ]))
    ])
  ], 512))
}